module.exports = __webpack_public_path__ + "img/guanbi.9a0565e7.png";